// Bushtech Wellside Canopy catalog — scraped from xpeditionz.co.nz Feb 2026
// Fully welded aluminium canopy platform, adapted per vehicle. GST-inc NZD prices.

export const WELLSIDE_FEATURES = [
  "**Fully welded aluminium frame** — one seamless structure, not bolted together in pieces like cheaper canopies",
  "**Advanced Dust Sealing** — a precision-moulded rear door wraps down and over the tailgate's exact contours, **purpose-built for class-leading dust sealing**, proven on permanently off-road African desert fleets and thoroughly tested in NZ",
  "**300kg dynamic roof load rating**, load-tested to 2.5 tonnes — 50% stronger than the nearest competitor",
  "**Typically just 65kg** — lighter than even plastic or fibreglass canopies despite the unmatched strength",
  "**Larger gullwing side access** — some of the biggest side openings on the market, with door-mounted (not frame-mounted) seals so loading and unloading through the side doors won't catch or tear them",
  "**Security by design** — internally braced, double-locked doors with locks and gas struts mounted to the frame, not thin door skins",
  "**Hand-finished TIG welds and a premium UV-resistant powder-coat** — still looks new after years of exposure to NZ's harsh sun",
  "**Reinforced roof rack tracks pre-installed as standard** — ready for roof tents, awnings, solar panels and roof racks",
  "**10-year manufacturer frame guarantee**",
  "**Supplied fully built and ready to fit** — no assembly required, typical 1-hour install, or use one of our experienced installation partners nationwide",
];

export const WELLSIDE_MODELS = [
  {
    slug: "hilux-2026-onwards",
    inStock: false,
    name: "Toyota Hilux 2026 Onwards",
    variants: "SR, SR5, Adventure",
    price: 5990,
    status: "Coming Soon",
    tagline: "For the All-New Generation Hilux",
    thumb: "/products/wellsides/731077_965bc7e8fce44fa38c6bb966e7a68bdf~mv2.jpg",
    intro: "Bushtech's genuine OEM-grade aluminium canopy, configured for the all-new 2026-onwards Toyota Hilux across SR, SR5 and Adventure trims. Fully welded aluminium frame — not bolt-together — delivering NZ's only genuine 300kg dynamic roof load rating, tested to 2.5 tonnes.",
    gallery: [
      "/products/wellsides/731077_05d7dbaf551b42888546931b93d0d3b6~mv2.jpg",
      "/products/wellsides/731077_965bc7e8fce44fa38c6bb966e7a68bdf~mv2.jpg",
      "/products/wellsides/731077_b9af06443f99420aa4c6c4009436bd4f~mv2.jpg",
      "/products/wellsides/731077_13a00fd3a8684c11969f42f653b9c2c7~mv2.jpg",
      "/products/wellsides/731077_1e7c336312c2470494c153eadb548245~mv2.jpg",
      "/products/wellsides/731077_dac568b6756a43eb874b97c74ee6af59~mv2.jpg",
      "/products/wellsides/731077_3d14b73003984bc683cfae96546832c9~mv2.jpg",
      "/products/wellsides/731077_91dc03ba4cb5456bb47838163bb25327~mv2.jpg",
      "/products/wellsides/731077_5eceb7584fce479786ff47d7be8b11d2~mv2.jpg",
    ],
    availability: "Coming soon — enquire to reserve",
  },
  {
    slug: "hilux-2016-2025",
    name: "Toyota Hilux 2016 to 2025",
    variants: "SR5, Cruiser, GR",
    price: 5990,
    priceFrom: true,
    status: "In Stock",
    optionGroups: [
      { key: "colour", label: "Colour", required: true, choices: [{ label: "Dark Grey", priceDelta: 0 }, { label: "Black", priceDelta: 0 }] },
      { key: "glass", label: "With or Without Glass", required: true, choices: [{ label: "All Solid Aluminium", priceDelta: 0 }, { label: "Glass Front & Rear", priceDelta: 400 }] },
    ],
    tagline: "Properly Equipped for Trade & Off-Road Use",
    thumb: "/products/wellsides/731077_e99532b6f8934f559e49154524d312f6~mv2.jpg",
    intro: "Bushtech's flagship aluminium canopy for the 2016 to 2025 Toyota Hilux. Fully welded aluminium frame, not bolt-together, delivering genuine OEM-grade strength, sealing and long-term durability for demanding trade and off-road use.",
    gallery: [
      "/products/wellsides/731077_993b910212a044c4a78fe958cc6a4878~mv2.jpg",
      "/products/wellsides/731077_e99532b6f8934f559e49154524d312f6~mv2.jpg",
      "/products/wellsides/731077_a2f38a39892445d3be8b770bba45d815~mv2.jpg",
      "/products/wellsides/731077_daffa70bda084c7f936261eea903332b~mv2.jpg",
      "/products/wellsides/731077_e18614e2b8244fa2a667c5dbd941f597~mv2.jpg",
      "/products/wellsides/731077_a07494c2652a48a5ac812c078e8dfeb8~mv2.jpg",
      "/products/wellsides/731077_fcab9d64d86346d8b876ad5b04e4a2b7~mv2.jpg",
      "/products/wellsides/731077_7cec10fcd2364c5f9a57f26cf3b9f019~mv2.jpg",
      "/products/wellsides/731077_193a02c8f1584fcd9b5e2b23b0f420bc~mv2.jpg",
      "/products/wellsides/731077_1ccc15bc95644ecc9ca3deece5311652~mv2.jpg",
      "/products/wellsides/731077_5271071c47ff489ba4ee51913bd687fb~mv2.jpg",
      "/products/wellsides/731077_b8121b1ca30d4a89bf978fadf3700dc9~mv2.jpg",
      "/products/wellsides/731077_ef907f62f0d74c2bb9f9403f50e6f265~mv2.jpg",
      "/products/wellsides/731077_491288a191794418a4d367c8c15b4da9~mv2.jpg",
    ],
    availability: "In stock",
  },
  {
    slug: "hilux-sr-2016-present",
    name: "Toyota Hilux SR 2016 to Present",
    variants: "Double Cab",
    price: 5990,
    priceFrom: true,
    status: "In Stock",
    optionGroups: [
      { key: "glass", label: "With or Without Glass", required: true, choices: [{ label: "All Solid Aluminium", priceDelta: 0 }, { label: "Glass Front & Rear", priceDelta: 400 }] },
    ],
    tagline: "Double Cab — SR Trim Wellside",
    thumb: "/products/wellsides/731077_35f8de54b80a46d58ea781452c8f7648~mv2.jpg",
    intro: "Bushtech aluminium canopy sized specifically for the Toyota Hilux SR double cab, which uses a slightly different wellside configuration to other Hilux double-cab variants — requiring its own distinct canopy fit. Same fully welded frame construction and 300kg dynamic load rating as the rest of the Hilux range.",
    gallery: [
      "/products/wellsides/731077_bccff67c73224d7fa8a43e638024bb4d~mv2.jpg",
      "/products/wellsides/731077_35f8de54b80a46d58ea781452c8f7648~mv2.jpg",
      "/products/wellsides/731077_a648a44fa17b4a59810e79c3d107f824~mv2.jpg",
      "/products/wellsides/731077_0709096513674707a206d31789166e54~mv2.jpeg",
      "/products/wellsides/731077_1ba0b52bb1f64726ae26adbf9bc3a869~mv2.jpeg",
      "/products/wellsides/731077_d790338669994802b4be9f658d9960ec~mv2.jpeg",
    ],
    availability: "In stock",
  },
  {
    slug: "hilux-2004-2015",
    name: "Toyota Hilux 2004 to 2015",
    variants: "SR5 — On Sale",
    price: 4990,
    originalPrice: 5990,
    status: "On Sale",
    optionGroups: [
      { key: "glass", label: "With or Without Glass", required: true, choices: [{ label: "All Solid Aluminium", priceDelta: 0 }, { label: "Glass Front & Rear", priceDelta: 400 }] },
    ],
    tagline: "Legacy Hilux, Current-Gen Canopy",
    thumb: "/products/wellsides/731077_fc75f9df731749b78078fcb054e8307c~mv2.jpg",
    intro: "Bushtech's aluminium canopy built to fit the long-running 2004 to 2015 Hilux SR5. Now on sale — same fully-welded aluminium frame, 300kg dynamic load rating and 10-year frame guarantee as the current model range.",
    gallery: [
      "/products/wellsides/731077_40c94086313948c487eccde2535007ea~mv2.jpeg",
      "/products/wellsides/731077_fc75f9df731749b78078fcb054e8307c~mv2.jpg",
      "/products/wellsides/731077_9de9c9313b7f40588fbe829c5606dc0e~mv2.jpg",
      "/products/wellsides/731077_98db09f2bea84b2f9925e18d10671660~mv2.jpg",
      "/products/wellsides/731077_42ed5dd0e3ea4dcd877bdd6d3926e162~mv2.jpeg",
      "/products/wellsides/731077_2a6b4098620b44bbb2ff9e479fcede4b~mv2.jpg",
      "/products/wellsides/731077_5c847d0b3f8b42f9918f5aa31c149d34~mv2.jpg",
      "/products/wellsides/731077_1eaf8a8947534db6abb0c40a5d95d23a~mv2.jpg",
    ],
    availability: "In stock — on sale",
  },
  {
    slug: "land-cruiser-79-series",
    name: "Toyota Land Cruiser 79 Series",
    variants: "Custom Build",
    price: null,
    priceOnRequest: true,
    status: "Special Order",
    tagline: "25 Years of Bushtech Engineering",
    thumb: "/products/wellsides/731077_e245a84fcf44424fa96fbefefc5d127d~mv2.jpg",
    intro: "No one builds aluminium canopies like Bushtech — the result of 25 years' industry experience, born out of the heat and dust of Africa. NZ's strongest canopies by far, and still lighter, with the only genuine 300kg dynamic roof load limit in NZ, tested to 2.5 tonnes. Custom-built for the 79 Series Land Cruiser — request the catalogue for a quote with your options selected.",
    gallery: [
      "/products/wellsides/731077_e245a84fcf44424fa96fbefefc5d127d~mv2.jpg",
      "/products/wellsides/731077_a0e62574c9ef444dab9f26f5f940b4d0~mv2.jpg",
      "/products/wellsides/731077_73be9b24243d4490b3c9ec19e9056c8c~mv2.jpg",
      "/products/wellsides/731077_0146db590f8546338669332332e35f13~mv2.jpg",
      "/products/wellsides/731077_1a611355a3104ed0be6b56bf14e7b1ae~mv2.jpg",
      "/products/wellsides/731077_273a2a561cf742779bb54f1fc4a3fcbb~mv2.jpg",
      "/products/wellsides/731077_e0cd1330d1f145fd82fcd0593ba294ba~mv2.jpg",
      "/products/wellsides/731077_500faf879260436dbeadb23ec69c8789~mv2.jpg",
      "/products/wellsides/731077_da9db475610e41e59039d7c47ad7b97c~mv2.jpg",
      { src: "/products/wellsides/731077_32132ec96519481c8c8f95a4b2213afb~mv2.jpg", pos: "75% center" },
    ],
    availability: "Special order — enquire",
  },
  {
    slug: "ford-ranger-2022-onwards",
    name: "Ford Ranger 2022 Onwards",
    variants: "Next Gen — Dark Grey or Black",
    price: 6190,
    priceFrom: true,
    status: "In Stock",
    optionGroups: [
      { key: "colour", label: "Colour", required: true, choices: [{ label: "Dark Grey", priceDelta: 0 }, { label: "Black", priceDelta: 0 }] },
      { key: "glass", label: "With or Without Glass", required: true, choices: [{ label: "All Solid", priceDelta: 0 }, { label: "Glass Front & Rear", priceDelta: 400 }] },
    ],
    tagline: "Next-Gen Ranger · Solid or Glass Door Options",
    thumb: "/products/wellsides/731077_327661e3e2154fd9968715252cb80dc5~mv2.jpeg",
    intro: "Bushtech aluminium canopy built for the Next-Gen Ford Ranger (2022 onwards). Available in dark grey or black powder-coat, with all-solid or glass window door options. Same welded aluminium frame and 300kg dynamic load rating across the range.",
    gallery: [
      { src: "/products/wellsides/731077_327661e3e2154fd9968715252cb80dc5~mv2.jpeg", pos: "42% center" },
      { src: "/products/wellsides/731077_90b9006c3324488e93c130524f286bfc~mv2.jpeg", pos: "15% center" },
      { src: "/products/wellsides/731077_2603300a1a4242d68d25f5b11762bfcd~mv2.jpeg", pos: "20% center" },
      { src: "/products/wellsides/731077_9f32914131cc412e8e727ad900ede9f5~mv2.jpg", pos: "60% center" },
      "/products/wellsides/731077_b526197e1564432c9cfb787d8cc013ff~mv2.jpg",
      "/products/wellsides/731077_6df874c5f3844225a3bc06da13b71f1e~mv2.jpeg",
      "/products/wellsides/731077_a4997f6afaba43f29d3b1a100fbf416f~mv2.jpg",
      "/products/wellsides/731077_860e41abff00417c84d0d8422b3220e4~mv2.jpg",
    ],
    availability: "In stock",
  },
  {
    slug: "ford-ranger-2012-2022",
    name: "Ford Ranger 2012 to 2022",
    variants: "Black or Dark Grey",
    price: 5490,
    originalPrice: 5990,
    status: "On Sale",
    optionGroups: [
      { key: "colour", label: "Colour", required: true, choices: [{ label: "Dark Grey", priceDelta: 0 }, { label: "Black", priceDelta: 0 }] },
      { key: "glass", label: "With or Without Glass", required: true, choices: [{ label: "All Solid", priceDelta: 0 }, { label: "Glass Front & Rear", priceDelta: 400 }] },
    ],
    tagline: "Previous-Gen Ranger & Mazda BT-50",
    thumb: "/products/wellsides/731077_b6cc68cec3a941d793bd9600fcf0e2ab~mv2.jpg",
    intro: "Bushtech aluminium canopy fitted to the previous-generation Ford Ranger and Mazda BT-50 (2012 to 2022), in black or dark grey powder-coat. Now on sale — the same fully-welded frame construction and 300kg dynamic load rating as every Bushtech canopy.",
    gallery: [
      "/products/wellsides/731077_b6cc68cec3a941d793bd9600fcf0e2ab~mv2.jpg",
      "/products/wellsides/731077_1928d7d127e94c7eaed4ee3a46a0ec0f~mv2.jpg",
      "/products/wellsides/731077_23951d40279a44f2952ca9307e2d0e75f002.jpg",
    ],
    availability: "In stock — on sale",
  },
  {
    slug: "vw-amarok-2023-onwards",
    name: "VW Amarok 2023 Onwards",
    variants: "New Generation",
    price: 6190,
    priceFrom: true,
    status: "In Stock",
    optionGroups: [
      { key: "glass", label: "With or Without Glass", required: true, choices: [{ label: "All Solid Aluminium", priceDelta: 0 }, { label: "Glass Front & Rear", priceDelta: 400 }] },
    ],
    tagline: "New-Generation Amarok",
    thumb: "/products/wellsides/731077_741974e197694285b8932b98ce69bdf8~mv2.jpg",
    intro: "Bushtech aluminium canopy engineered for the new-generation Volkswagen Amarok (2023 onwards), shared underpinnings with the Next-Gen Ranger. Fully welded aluminium frame, 300kg dynamic load rating, 10-year frame guarantee.",
    gallery: [
      "/products/wellsides/731077_b1b6a3d21fec47eea20fdbdbcf3d9ba7~mv2.jpg",
      "/products/wellsides/731077_741974e197694285b8932b98ce69bdf8~mv2.jpg",
    ],
    availability: "In stock",
  },
  {
    slug: "vw-amarok-2010-2021",
    inStock: false,
    name: "VW Amarok 2010 to 2021",
    variants: "Special Order",
    price: 5990,
    priceFrom: true,
    status: "Special Order",
    tagline: "Original-Generation Amarok",
    thumb: "/products/wellsides/731077_d9b69450fcc74068a79b56327513e392~mv2.jpg",
    intro: "Bushtech aluminium canopy built to order for the original-generation Volkswagen Amarok (2010 to 2021). Same fully-welded aluminium frame and 300kg dynamic load rating as the rest of the Bushtech range — enquire for current lead time.",
    gallery: [
      "/products/wellsides/731077_d9b69450fcc74068a79b56327513e392~mv2.jpg",
      "/products/wellsides/731077_f31285be8d7f4b1a98be4c4c082d6deb~mv2.jpg",
      "/products/wellsides/731077_c154c6f8e60048a09e369861a5e904cf~mv2.jpg",
      "/products/wellsides/731077_1bce814d677b47bdbd084fbb195ecaf9~mv2.jpg",
      "/products/wellsides/731077_d7b8e18b4d2e4b9383e85c0a4462d597~mv2.jpeg",
      "/products/wellsides/731077_45a5e25587f14209940fd19e3c2c06e5~mv2.jpeg",
      "/products/wellsides/731077_9b6f660eda954052b0856a91d639319b~mv2.jpeg",
      "/products/wellsides/731077_a2f02a1b0361414ba132f25ccf99bf06~mv2.jpeg",
      "/products/wellsides/731077_d12705a2efb54fafae5d182b4396b7dd~mv2.jpg",
    ],
    availability: "Special order — enquire",
  },
  {
    slug: "isuzu-dmax-2019-present",
    name: "Isuzu D-Max 2019 to Present",
    variants: "Black",
    price: 5990,
    priceFrom: true,
    status: "In Stock",
    optionGroups: [
      { key: "glass", label: "With or Without Glass", required: true, choices: [{ label: "All Solid Aluminium", priceDelta: 0 }, { label: "Glass Front & Rear", priceDelta: 400 }] },
    ],
    tagline: "Current-Gen D-Max",
    thumb: "/products/wellsides/731077_57cf0ccd493441d9a7f946fd95c921af~mv2.jpg",
    intro: "Bushtech aluminium canopy for the current-generation Isuzu D-Max (2019 to present) in black powder-coat. Fully welded aluminium frame, 300kg dynamic load rating, tested to 2.5 tonnes.",
    gallery: [
      "/products/wellsides/731077_57cf0ccd493441d9a7f946fd95c921af~mv2.jpg",
      "/products/wellsides/731077_abd858cd5a3d4717815c40515c08da69~mv2.jpg",
      "/products/wellsides/731077_865bf89765f54567a55cdc9440c66f55~mv2.jpg",
      "/products/wellsides/731077_542a73284d244699ad39afbd4dfee4ec~mv2.jpg",
      "/products/wellsides/731077_fb7ba73060734ece9c3199948be852dd~mv2.jpg",
      "/products/wellsides/731077_0581f207ae0a4f9e9e4feecc053e1f5d~mv2.jpg",
      "/products/wellsides/731077_1b43d47e5788427ead9df18ca1bdbb53~mv2.jpg",
    ],
    availability: "In stock",
  },
  {
    slug: "isuzu-dmax-2012-2018",
    inStock: false,
    name: "Isuzu D-Max 2012 to 2018",
    variants: "Black or Dark Grey",
    price: 5990,
    priceFrom: true,
    status: "Pre-Order",
    optionGroups: [
      { key: "colour", label: "Colour", required: true, choices: [{ label: "Dark Grey", priceDelta: 0 }, { label: "Black", priceDelta: 0 }] },
      { key: "glass", label: "With or Without Glass", required: true, choices: [{ label: "All Solid Aluminium", priceDelta: 0 }, { label: "Glass Front & Rear", priceDelta: 400 }] },
    ],
    tagline: "Previous-Gen D-Max",
    thumb: "/products/wellsides/731077_9e0357429f65456cbff8d8fc57e8a322~mv2.jpg",
    intro: "Bushtech aluminium canopy built to fit the 2012 to 2018 Isuzu D-Max, available in black or dark grey powder-coat. Fully welded aluminium frame, 300kg dynamic load rating, 10-year frame guarantee.",
    gallery: [
      "/products/wellsides/731077_9e0357429f65456cbff8d8fc57e8a322~mv2.jpg",
      "/products/wellsides/731077_aa40fe2d7ec84b7b8a232d237cfe5d74~mv2.jpg",
      "/products/wellsides/731077_8a923c9a51f6464bafaea1b8c4139147~mv2.jpg",
      "/products/wellsides/731077_3e71b9b742ea41dd88cabbd7a2f4b560~mv2.jpg",
      "/products/wellsides/731077_fe40359c9b9c488b9cf625fd7babcb6b~mv2.jpg",
      "/products/wellsides/731077_f2480fa15b1f40babacd7c0ca97202c7~mv2.jpg",
    ],
    availability: "Pre-order — enquire",
  },
  {
    slug: "mazda-bt50-2019-2024",
    name: "Mazda BT-50 2019 to 2024",
    variants: "Premium Aluminium",
    price: 5990,
    priceFrom: true,
    status: "In Stock",
    optionGroups: [
      { key: "glass", label: "With or Without Glass", required: true, choices: [{ label: "All Solid", priceDelta: 0 }, { label: "With Glass", priceDelta: 400 }] },
    ],
    tagline: "Current-Gen BT-50",
    thumb: "/products/wellsides/731077_b8aee2ac5e2849579c5d3008dc8088ff~mv2.jpg",
    heroPosition: "70% 20%",
    intro: "Bushtech premium aluminium canopy for the current-generation Mazda BT-50 (2019 to 2024, Isuzu D-Max platform). Fully welded aluminium frame, 300kg dynamic load rating, tested to 2.5 tonnes.",
    gallery: [
      { src: "/products/wellsides/731077_b8aee2ac5e2849579c5d3008dc8088ff~mv2.jpg", pos: "70% center" },
      { src: "/products/wellsides/731077_4a72fd727e5f46f297a03c54922220e2~mv2.jpg", pos: "70% center" },
      "/products/wellsides/731077_cf4d85fd8c5f4c24b5a96715d7c622ff~mv2.jpg",
      "/products/wellsides/731077_70fa4820e34c4b929bcd4329a6f96ef7~mv2.jpg",
      "/products/wellsides/731077_c762c2935a0e4157804ce2f4fa9f7f51~mv2.jpg",
      "/products/wellsides/731077_944df3bf3b4d4737a85bdab794de5df3~mv2.jpg",
      "/products/wellsides/731077_4e775eb89e3246c59ebe004c272b16f6~mv2.jpg",
      "/products/wellsides/731077_e47f6a8bd6f6415eac89b39032d10327~mv2.jpg",
    ],
    availability: "In stock",
  },
  {
    slug: "mazda-bt50-2012-2018",
    name: "Mazda BT-50 2012 to 2018",
    variants: "Black or Dark Grey",
    price: 5990,
    priceFrom: true,
    status: "In Stock",
    optionGroups: [
      { key: "colour", label: "Colour", required: true, choices: [{ label: "Dark Grey", priceDelta: 0 }, { label: "Black", priceDelta: 0 }] },
      { key: "glass", label: "With or Without Glass", required: true, choices: [{ label: "All Solid", priceDelta: 0 }, { label: "With Glass", priceDelta: 400 }] },
    ],
    tagline: "Previous-Gen BT-50 · Glass or All-Solid",
    thumb: "/products/wellsides/731077_64960fd6e51f419bba90e87dd95da05b~mv2.jpg",
    heroPosition: "75% 20%",
    intro: "Bushtech aluminium canopy for the previous-generation Mazda BT-50 (2012 to 2018/2019), in black or dark grey powder-coat with glass or all-solid door options. Fully welded aluminium frame, 300kg dynamic load rating.",
    gallery: [
      { src: "/products/wellsides/731077_64960fd6e51f419bba90e87dd95da05b~mv2.jpg", pos: "75% center" },
      "/products/wellsides/731077_0c8d8e19959240039383439f47d0dcbf~mv2.jpg",
      { src: "/products/wellsides/731077_6f68dd0c90b94c8e97079a1879e54b5e~mv2.jpg", pos: "60% center" },
      "/products/wellsides/731077_a94953b2d28d4820a48c00d12cfebf8b~mv2.jpg",
      "/products/wellsides/731077_eda3283098f24f0f85c934407be14930~mv2.jpg",
      "/products/wellsides/731077_0e2eb1e485ca4979bd364ce426ca11d2~mv2.jpg",
    ],
    availability: "In stock",
  },
  {
    slug: "nissan-navara-2021-2024",
    name: "Nissan Navara 2021 to 2024",
    variants: "Black Smooth Aluminium",
    price: 6390,
    status: "In Stock",
    tagline: "Facelift Navara D23",
    thumb: "/products/wellsides/731077_230fa9738e4d4bae914685f6a690b9d4~mv2.jpg",
    intro: "Bushtech aluminium canopy in black smooth finish for the facelift Nissan Navara (2021 to 2024). Fully welded aluminium frame, 300kg dynamic load rating, tested to 2.5 tonnes, trusted for fitment on new utes at NZ dealerships.",
    gallery: [
      "/products/wellsides/731077_230fa9738e4d4bae914685f6a690b9d4~mv2.jpg",
      "/products/wellsides/731077_1c4ff51124a44aa783148c94e0643903~mv2.jpg",
      "/products/wellsides/731077_d5282fd2599d46c29a399a9ef24fc8f6~mv2.jpg",
      "/products/wellsides/731077_fda45ee054cb43fc9caf2d24c673f95b~mv2.jpg",
      "/products/wellsides/731077_1e23b0bb9ae645b9bc8f677b1d295e3c~mv2.jpg",
      "/products/wellsides/731077_92945f50c03f4fbebe97c2301dec13ab~mv2.jpg",
      "/products/wellsides/731077_31fa6df761834ec3a760fd9fe6d0cf4e~mv2.jpg",
      "/products/wellsides/731077_a6dd405354c3440789da6285f81cb0f0~mv2.jpg",
    ],
    availability: "In stock",
  },
  {
    slug: "nissan-navara-d23",
    inStock: false,
    name: "Nissan Navara 2014 to 2021",
    variants: "D23",
    price: 6190,
    status: "Pre-Order",
    tagline: "Original D23 Navara",
    thumb: "/products/wellsides/731077_c1e7abc70827498eade187bf07a7ee40~mv2.jpg",
    intro: "Bushtech aluminium canopy for the original D23-generation Nissan Navara (2014 to 2021). Fit at home using supplied instructions, or use one of our experienced installation partners nationwide. Fully welded aluminium frame, 300kg dynamic load rating.",
    gallery: [
      "/products/wellsides/731077_c1e7abc70827498eade187bf07a7ee40~mv2.jpg",
      "/products/wellsides/731077_8e164b90375d4375aabd1658b0c2db96~mv2.jpg",
      "/products/wellsides/731077_d6fc44db149641119d16d2bb5b934098~mv2.jpg",
      "/products/wellsides/731077_c9fe4e11e677480f909a6628065bc894~mv2.jpg",
      { src: "/products/wellsides/731077_921147730530467c8f148e8202d768df~mv2.jpg", pos: "25% center" },
      "/products/wellsides/731077_557451bc6f9e4377adb11b4a56f3ff96~mv2.jpg",
      "/products/wellsides/731077_dd86902099fc4e5c9427112b91082ac4~mv2.jpg",
    ],
    availability: "Pre-order — enquire",
  },
  {
    slug: "nissan-navara-d40",
    inStock: false,
    name: "Nissan Navara D40",
    variants: "Special Order",
    price: 5990,
    status: "Special Order",
    tagline: "Legacy D40 Navara",
    thumb: "/products/wellsides/731077_dcf21d752ea4492f805943fe944c3339~mv2.jpg",
    intro: "Bushtech aluminium canopy built to order for the legacy D40-generation Nissan Navara. Fully welded aluminium frame, 300kg dynamic load rating, 10-year frame guarantee — enquire for current lead time.",
    gallery: [
      { src: "/products/wellsides/731077_dcf21d752ea4492f805943fe944c3339~mv2.jpg", pos: "30% center" },
      { src: "/products/wellsides/731077_5d234eb22fd2459497192cbeaaf32914~mv2.jpg", pos: "30% center" },
      { src: "/products/wellsides/731077_7135b5f31e8047d98c9a043bdaad90d6~mv2.jpg", pos: "25% center" },
      "/products/wellsides/731077_53807d56157f4880a24352d5f590e5e9~mv2.jpg",
      "/products/wellsides/731077_4d1a02afea0e423c96cf7c999c68674b~mv2.jpg",
      "/products/wellsides/731077_74c3e21d2722460f8e5a725f011931da~mv2.jpg",
    ],
    availability: "Special order — enquire",
  },
  {
    slug: "jeep-gladiator",
    name: "Jeep Gladiator",
    variants: "Black",
    price: 6890,
    status: "In Stock",
    tagline: "Built for the Gladiator's Unique Tub",
    thumb: "/products/wellsides/731077_495d761479394757b70bd420b5211f57~mv2.jpg",
    intro: "Bushtech aluminium canopy in black powder-coat, engineered for the Jeep Gladiator's tub. Fully welded aluminium frame, 300kg dynamic load rating, tested to 2.5 tonnes.",
    gallery: [
      "/products/wellsides/731077_495d761479394757b70bd420b5211f57~mv2.jpg",
      "/products/wellsides/731077_2b00d06da22f4940be1cc3b7401f3516~mv2.jpg",
      "/products/wellsides/731077_2416c5c3cb924d3a8aa00ee413837fce~mv2.jpg",
      "/products/wellsides/731077_3f9721483696456b91fbbe89f9dc5e20~mv2.jpg",
      "/products/wellsides/731077_ef25da5d41b246658f346222ac592481~mv2.jpg",
      "/products/wellsides/731077_e3562828d4cc41e1afeb73a913181167~mv2.jpg",
      "/products/wellsides/731077_c6a96bd41bac485394aaa20d044f5551~mv2.jpg",
      "/products/wellsides/731077_6174626e9f334a9ba07b447321badb9d~mv2.jpg",
    ],
    availability: "In stock",
  },
  {
    slug: "jac-t9",
    name: "JAC T9 Ute",
    variants: "Premium Aluminium",
    price: 5990,
    priceFrom: true,
    status: "In Stock",
    optionGroups: [
      { key: "glass", label: "With or Without Glass", required: true, choices: [{ label: "All Solid", priceDelta: 0 }, { label: "Glass Front & Rear", priceDelta: 400 }] },
    ],
    tagline: "Strongest on the Market",
    thumb: "/products/wellsides/731077_87a806ceeaf84aaab4f0a5107a5e2d37~mv2.jpg",
    intro: "Bushtech aluminium canopy for the JAC T9 ute — the strongest canopy on the NZ market with a genuine 300kg dynamic load capacity, tested to 2.5 tonnes.",
    gallery: [
      "/products/wellsides/731077_87a806ceeaf84aaab4f0a5107a5e2d37~mv2.jpg",
      "/products/wellsides/731077_ea9bb05ae0594ba7888b873e243ae9d3~mv2.jpg",
      "/products/wellsides/731077_822f31e498e14c20ae5c23b585c84971~mv2.jpg",
      "/products/wellsides/731077_82896d98045a444c99d439bb8f6d3dd8~mv2.jpg",
      "/products/wellsides/731077_3265dc85799946479111ca2d26511132~mv2.jpg",
      "/products/wellsides/731077_0267a96317b54c23ba6d1d71860c90eb~mv2.jpg",
      "/products/wellsides/731077_ea04735dbab947c695efadcd465ee721~mv2.jpg",
    ],
    availability: "In stock",
  },
  {
    slug: "holden-colorado",
    inStock: false,
    name: "Holden Colorado 2012 to 2020",
    variants: "Black",
    price: 5990,
    priceFrom: true,
    status: "Pre-Order",
    optionGroups: [
      { key: "glass", label: "With or Without Glass", required: true, choices: [{ label: "All Solid Aluminium", priceDelta: 0 }, { label: "Glass Front & Rear", priceDelta: 400 }] },
    ],
    tagline: "The Strongest Canopy for the Colorado",
    thumb: "/products/wellsides/731077_6c995e447eaf4b968ab83a6730cad511~mv2.jpg",
    intro: "The strongest and best quality aluminium canopy on the NZ market for the Holden Colorado (2012 to 2020), in smooth black aluminium finish.",
    gallery: [
      "/products/wellsides/731077_6c995e447eaf4b968ab83a6730cad511~mv2.jpg",
      "/products/wellsides/731077_d1a0d36d4ea147a183ebe502892185ce~mv2.jpg",
      "/products/wellsides/731077_884fe34fceb34c1b8c1338db5836ef9d~mv2.jpg",
      "/products/wellsides/731077_0667443df40b4a5ba1e9f5b3f537f6a2~mv2.jpg",
      "/products/wellsides/731077_c42a13ecfdda43b3b011c432ce835460~mv2.jpg",
      "/products/wellsides/731077_9bceb94b601140c4b9493fa1c0bfabd4~mv2.jpg",
      "/products/wellsides/731077_4408f008cdf54b6db28f696d35b14597~mv2.jpg",
      "/products/wellsides/731077_d1eaf68ce04c4745b21846db64a2c8a2~mv2.jpg",
      "/products/wellsides/731077_dceae4610606427784636e8a35d39d47~mv2.jpg",
      "/products/wellsides/731077_55dae18352bb47a08e86e478930b9d58~mv2.jpg",
      "/products/wellsides/731077_6f41e5fc94ba4db99efe03db0a12517a~mv2.jpg",
    ],
    availability: "Pre-order — enquire",
  },
  {
    slug: "ineos-quartermaster",
    inStock: false,
    name: "INEOS Quartermaster",
    variants: "Premium Build",
    price: 8575,
    priceFrom: true,
    status: "New",
    optionGroups: [
      { key: "plate", label: "Aluminium Plate", required: true, choices: [{ label: "Smooth", priceDelta: 0 }, { label: "Tread", priceDelta: 0 }] },
      { key: "glass", label: "Glass or Solid Aluminium", required: true, choices: [
        { label: "All Aluminium Canopy and Doors", priceDelta: 0 },
        { label: "Standard Glass Front and Rear", priceDelta: 400 },
        { label: "Cab Slider Front with 6mm Laminated Rear Glass", priceDelta: 700 },
      ] },
    ],
    tagline: "Built to Match a Different Standard of Ute",
    thumb: "/products/wellsides/731077_cadce0842cc545f8b360f699ec431a02~mv2.jpg",
    intro: "The INEOS Quartermaster demands a different standard of canopy. Bushtech's fully TIG-welded aluminium frame is engineered and proven in harsh African conditions, where dust ingress, structural fatigue and long-term durability are non-negotiable. The rear door profile is shaped to follow the Quartermaster's tailgate, combined with Bushtech's proven dust-sealing system — configured specifically for this platform with limited build allocations available.",
    features: [
      "Fully TIG-welded aluminium frame construction",
      "300kg dynamic roof load rating (tested to 2.5 tonnes)",
      "Structural design for sustained off-road loads",
      "Integrated dust and water sealing system, shaped to follow the Quartermaster tailgate — door-mounted (not frame-mounted) seals so opening the full-size gullwing doors doesn't drag or tear the rubber",
      "Optional wellside dust-sealing kit available for even further-enhanced sealing",
      "Standard filtered vent fitted to every canopy — circulates air inside the load box without letting dust in",
      "Security by design — internally braced, double-locked doors with locks and gas struts mounted to the frame, not thin door skins. In real-world use, Bushtech canopies are rarely targeted compared to other canopy types",
      "Premium UV-resistant powder-coat finish",
      "10-year manufacturer frame guarantee",
      "Supplied fully built and ready to fit — no assembly required, typical 1-hour install",
      "Fit it yourself using the supplied instructions, or use one of our experienced installation partners nationwide",
    ],
    gallery: [
      "/products/wellsides/731077_cadce0842cc545f8b360f699ec431a02~mv2.jpg",
      "/products/wellsides/731077_d9598a5611c14de79721efbc274d9759~mv2.jpg",
      "/products/wellsides/731077_80f82e62cbb04eae80c0022ff84de0bb~mv2.jpg",
      "/products/wellsides/731077_989297845bed4a5d9fe97fdb89c5e173~mv2.jpg",
      "/products/wellsides/731077_ca9733efc00640a99ec4bcae41afd82f~mv2.jpg",
      "/products/wellsides/731077_ee73d9f0bbeb4d609305580887533304~mv2.jpg",
      "/products/wellsides/731077_387804ef653c422293af189c315c889d~mv2.jpg",
      "/products/wellsides/731077_c1f24cbb20604cc299abd36b198cdb59~mv2.jpg",
      "/products/wellsides/731077_1e2580037b65498dafbff5a40136ddb1~mv2.jpg",
      "/products/wellsides/731077_a963ec29c3f9418ab5250a5bd8225348~mv2.jpg",
      "/products/wellsides/731077_aeb0044db42c467eadc50312bc765b06~mv2.jpg",
    ],
    availability: "Limited build allocations — enquire",
  },
  {
    slug: "land-rover-defender",
    name: "Land Rover Defender 110/130",
    variants: "Built to Order",
    price: null,
    priceOnRequest: true,
    status: "Built to Order",
    tagline: "Twice-Yearly Production Run",
    thumb: "/products/wellsides/731077_9d9d1353efa74c1e90520c101ee0c7a5~mv2.jpg",
    intro: "XpeditioNZ is the exclusive Bushtech importer for New Zealand, also supplying Australia. We bring this model twice a year — enquire for the current build schedule and a detailed quote with your options selected.",
    gallery: [
      "/products/wellsides/731077_9d9d1353efa74c1e90520c101ee0c7a5~mv2.jpg",
      "/products/wellsides/731077_c06a60d08e8543c4b2c36b387fb6e3a9~mv2.jpg",
      "/products/wellsides/731077_5d668762d1af483b803a19f3052129f5~mv2.jpg",
      "/products/wellsides/731077_58cb8c1b602743fb9ca5e0219d12c111~mv2.jpg",
      "/products/wellsides/731077_6280c4230b9f44f7a5d6ae0663079d05~mv2.jpg",
      "/products/wellsides/731077_d712086b86c74bf997198c558cf94e2d~mv2.jpg",
      "/products/wellsides/731077_b0bd24d801a7433aa33302e4108e9247~mv2.jpg",
      "/products/wellsides/731077_e40d113a15c74ad7abd8995bfcce3bf9~mv2.jpg",
      "/products/wellsides/731077_666f823260f04d9a92ddf2d7557341bd~mv2.jpg",
      "/products/wellsides/731077_e4b77700aa194f1084b337b5c1bf552e~mv2.jpg",
      "/products/wellsides/731077_dd24d7ba21154c9ab547b1c3a60bb9cc~mv2.jpg",
      "/products/wellsides/731077_30be6e63963a405f8243133c3caae45f~mv2.jpg",
      "/products/wellsides/731077_f890235ca6804d15afcf4964e8195ede~mv2.jpg",
      "/products/wellsides/731077_193db245e4d1488b94d4faddb01c1f94~mv2.jpg",
    ],
    availability: "Built to order — twice-yearly production run",
  },
  {
    slug: "byd-shark",
    inStock: false,
    name: "BYD Shark",
    variants: "Launching Soon",
    price: 5990,
    priceFrom: true,
    status: "Launching Soon",
    optionGroups: [
      { key: "colour", label: "Colour", required: true, choices: [{ label: "Dark Grey", priceDelta: 0 }, { label: "Black", priceDelta: 0 }] },
      { key: "glass", label: "With or Without Glass", required: true, choices: [{ label: "All Solid", priceDelta: 0 }, { label: "With Glass", priceDelta: 400 }] },
    ],
    tagline: "For NZ's First PHEV Ute",
    thumb: "/products/wellsides/731077_6ae6daedc29e4131a430776e496f82c7~mv2.avif",
    intro: "Bushtech aluminium canopy configured for the BYD Shark plug-in hybrid ute. Fully welded aluminium frame, 300kg dynamic load rating, 10-year frame guarantee — launching soon, enquire to be notified.",
    gallery: [
      "/products/wellsides/731077_6ae6daedc29e4131a430776e496f82c7~mv2.avif",
    ],
    availability: "Launching soon — enquire",
  },
  {
    slug: "gwm-cannon",
    inStock: false,
    name: "GWM Cannon",
    variants: "Launching Soon",
    price: 5990,
    priceFrom: true,
    status: "Launching Soon",
    optionGroups: [
      { key: "glass", label: "With or Without Glass", required: true, choices: [{ label: "All Solid", priceDelta: 0 }, { label: "Glass Front & Rear", priceDelta: 400 }] },
    ],
    tagline: "OEM-Grade Fitment, GWM Cannon",
    thumb: "/products/wellsides/731077_7cee63edbd0e43ff84aae3c6dff6a504~mv2.webp",
    intro: "Bushtech canopies are built around a fully TIG-welded aluminium frame — delivering true OEM-level strength, sealing and long-term durability for demanding trade and off-road applications on the GWM Cannon. Engineered in South Africa, proven worldwide, and trusted by NZ dealerships for new-vehicle fitment.",
    gallery: [
      "/products/wellsides/731077_7cee63edbd0e43ff84aae3c6dff6a504~mv2.webp",
    ],
    availability: "Launching soon — enquire",
  },
];

export const findWellside = (slug) => WELLSIDE_MODELS.find((m) => m.slug === slug);
